var map = {
	"./checkUnitInspectionTools.png": "0319",
	"./checkUnitMaterial.png": "b870",
	"./checkUnitPersonnel.png": "dfab",
	"./checkUnitToolVerifiable.png": "0b54",
	"./constructionCertificateExpires.png": "95e3",
	"./constructionMeasuringInstruments.png": "0eb4",
	"./metalLongBackground.png": "2cef",
	"./metalShortBackground.png": "fde5",
	"./specialtyComprehensive.png": "b962",
	"./specialtyContainerYear.png": "8a27",
	"./specialtyContainersRegularBasis.png": "2d5d",
	"./specialtyInsideBoiler.png": "73b8",
	"./specialtyOnline.png": "2898",
	"./specialtyOutsideBoiler.png": "5269",
	"./specialtyPressureCylinders.png": "9983",
	"./specialtyReliefValve.png": "d841",
	"./specialtySimplePressureVessels.png": "07e3",
	"./specialtySupportHanger.png": "36a9",
	"./statisticsEntrustCompletedNumber.png": "10a8",
	"./statisticsOrdersCompletedNumber.png": "7910",
	"./statisticsRate.png": "31731",
	"./statisticsReportsIssuedNumber.png": "4879",
	"./statisticsSafetyInspectionCommissionNumber.png": "6736",
	"./statisticsSamplesCompletedNumber.png": "b3b1"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7565";